import { InjectionToken } from '@angular/core';
import { MeterReadingsOutputConfig } from '@app/meter-readings/interfaces/meter-readings-output-config';

export const METER_READINGS_OUTPUT_CONFIG = new InjectionToken<MeterReadingsOutputConfig>('METER_READINGS_OUTPUT_CONFIG');
